import { ISurveyFormDisplayRuleDomainLegend } from "../../../../../../../../@types/Proms";
import { CircleLegend } from "../../../../../../../../assets/icons/CircleLegend";
import { Container, StyledLegend } from "./CustomPromsDomainTotalLegend.styles";

type CustomPromsLegendProps = {
  legends: ISurveyFormDisplayRuleDomainLegend[];
};

export function CustomPromsDomainTotalLegend({
  legends,
}: CustomPromsLegendProps) {
  const domainTotalLegends: any[] = [];

  legends
    .sort((a, b) => a.order - b.order)
    .map((legend: ISurveyFormDisplayRuleDomainLegend, index: number) => {
      domainTotalLegends.push(
        <StyledLegend key={`${legend.name}_${index}`}>
          <CircleLegend
            fill={legend.color}
            lineOpacity={0.38}
            legend
            focusMode
            isProms
          />
          {legend.name}
        </StyledLegend>
      );

      return null;
    });

  return <Container>{domainTotalLegends}</Container>;
}
